import { render, staticRenderFns } from "./iconPicker.vue?vue&type=template&id=2e8277e1"
import script from "./iconPicker.vue?vue&type=script&lang=js"
export * from "./iconPicker.vue?vue&type=script&lang=js"
import style0 from "./iconPicker.vue?vue&type=style&index=0&id=2e8277e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports